
@switch (type) {
  @case (tileTypes.LineGraph) {
    <ndt-line-icon></ndt-line-icon>
  }
  @case (tileTypes.PieGraph) {
    <ndt-pie-icon></ndt-pie-icon>
  }
  @case (tileTypes.PieGridGraph) {
    <ndt-pie-grid-icon></ndt-pie-grid-icon>
  }
  @case (tileTypes.BarGraph) {
    <ndt-bar-icon></ndt-bar-icon>
  }
  @case (tileTypes.Summary) {
    <ndt-summary-icon></ndt-summary-icon>
  }
  @case (tileTypes.Table) {
    <ndt-table-icon></ndt-table-icon>
  }
  @case (tileTypes.Clock) {
    <ndt-calendar-icon></ndt-calendar-icon>
  }
  @default {
    <div class="fallback-icon tile-type-mat-icon-wrapper">
      <mat-icon>question_mark</mat-icon>
    </div>
  }
}
